<template>
  <div class="container-fluid py-5">
    <div class="container-xxl">

      <h2 class="text-center fw-bold pt-5">
        Galeri Kegiatan <br />
        <span class="text-success fs-1">GAHARU Outbound</span>
      </h2>

      <!-- SLIDER -->
      <div
        class="gallery-slider py-5"
        @mouseenter="stopAutoScroll"
        @mouseleave="startAutoScroll"
      >

        <!-- LEFT BUTTON -->
        <button class="slider-btn left" @click="scrollLeft">
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- SCROLL AREA -->
        <div class="gallery-track" ref="scrollContainer">

          <div
            class="gallery-item"
            v-for="(img, index) in galleryImages"
            :key="index"
            @click="openModal(img)"
          >

            <!-- IMAGE WRAPPER -->
            <div class="gallery-image">
              <img :src="img.src" loading="lazy" />
            </div>

            <!-- WATERMARK -->
            <div class="watermark">
              <img src="../../../assets/logo_gaharu_white.png" />
            </div>

            <!-- OVERLAY -->
            <div class="gallery-overlay">
              <h6>{{ img.gallery.title }}</h6>
              <small>{{ img.gallery.location }}</small>
            </div>

          </div>

        </div>

        <!-- RIGHT BUTTON -->
        <button class="slider-btn right" @click="scrollRight">
          <i class="bi bi-chevron-right"></i>
        </button>

      </div>

      <!-- BUTTON VIEW ALL -->
      <div class="text-center mt-4">
        <router-link to="/galery">
          <button class="btn btn-success btn-animate-arrow">
            Lihat Semua Galeri
            <i class="bi bi-arrow-right-circle arrow-move"></i>
          </button>
        </router-link>
      </div>

    </div>

    <!-- MODAL -->
    <div class="modal fade" tabindex="-1" ref="modalRef">

      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0">

          <div class="modal-body p-0 text-center">

            <img
              v-if="selectedImage"
              :src="selectedImage"
              class="img-fluid w-100"
            />

            <div class="watermark modal-watermark">
              <img src="../../../assets/logo_gaharu_white.png" />
            </div>

          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from "vue";
import { Modal } from "bootstrap";

export default {

  setup() {

    const galleryImages = ref([]);
    const scrollContainer = ref(null);

    const selectedImage = ref(null);
    const modalRef = ref(null);
    let modalInstance = null;

    let autoScroll = null;

    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

    const fetchGallery = async () => {

      try {

        const response = await fetch(
          `${API_BASE_URL}/api/galeries/images?page=1&limit=12&sort=newest`
        );

        const result = await response.json();

        galleryImages.value = result.data.map((item) => ({
          src: item.img_url,
          gallery: item.galery,
        }));

      } catch (err) {

        console.error(err);

      }

    };

    /* SCROLL BUTTON */

    const scrollLeft = () => {

      scrollContainer.value.scrollBy({
        left: -350,
        behavior: "smooth",
      });

    };

    const scrollRight = () => {

      scrollContainer.value.scrollBy({
        left: 350,
        behavior: "smooth",
      });

    };

    /* AUTO SCROLL */

    const startAutoScroll = () => {

      stopAutoScroll();

      autoScroll = setInterval(() => {

        if (!scrollContainer.value) return;

        scrollContainer.value.scrollBy({
          left: 1,
          behavior: "auto",
        });

        if (
          scrollContainer.value.scrollLeft +
            scrollContainer.value.clientWidth >=
          scrollContainer.value.scrollWidth
        ) {
          scrollContainer.value.scrollLeft = 0;
        }

      }, 20);

    };

    const stopAutoScroll = () => {

      if (autoScroll) {
        clearInterval(autoScroll);
      }

    };

    /* MODAL */

    const openModal = async (img) => {

      selectedImage.value = img.src;

      await nextTick();

      if (!modalInstance) {
        modalInstance = new Modal(modalRef.value);
      }

      modalInstance.show();

    };

    onMounted(() => {

      fetchGallery();
      startAutoScroll();

    });

    onUnmounted(() => {
      stopAutoScroll();
    });

    return {
      galleryImages,
      scrollContainer,
      scrollLeft,
      scrollRight,
      openModal,
      selectedImage,
      modalRef,
      stopAutoScroll,
      startAutoScroll
    };

  },

};
</script>

<style scoped>

/* SLIDER */

.gallery-slider{
  position:relative;
}

/* SCROLL AREA */

.gallery-track{
  display:flex;
  gap:20px;
  overflow-x:auto;
  scroll-behavior:smooth;
  padding-bottom:10px;
}

.gallery-track::-webkit-scrollbar{
  display:none;
}

/* CARD */

.gallery-item{
  flex:0 0 auto;
  width:300px;
  border-radius:8px;
  overflow:hidden;
  position:relative;
  cursor:pointer;
}

/* IMAGE WRAPPER (SAFE IOS) */

.gallery-image{
  width:100%;
  aspect-ratio:4/3;
  overflow:hidden;
}

.gallery-image img{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
  transition:transform .4s;
}

.gallery-item:hover img{
  transform:scale(1.1);
}

/* OVERLAY */

.gallery-overlay{
  position:absolute;
  bottom:0;
  width:100%;
  padding:12px;
  color:white;
  background:linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  opacity:0;
  transition:.3s;
}

.gallery-item:hover .gallery-overlay{
  opacity:1;
}

/* WATERMARK */

.watermark{
  position:absolute;
  bottom:8px;
  right:8px;
  pointer-events:none;
}

.watermark img{
  height:20px;
  width:auto;
}

.modal-watermark img{
  height:40px;
}

/* BUTTON */

.slider-btn{
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  border:none;
  width:40px;
  height:40px;
  background:white;
  border-radius:50%;
  box-shadow:0 4px 10px rgba(0,0,0,.2);
  z-index:2;
}

.slider-btn.left{
  left:-10px;
}

.slider-btn.right{
  right:-10px;
}

.slider-btn:hover{
  background:#198754;
  color:white;
}

/* BUTTON ANIMATION */

.btn-animate-arrow{
  display:inline-flex;
  align-items:center;
  gap:8px;
}

.arrow-move{
  animation:moveArrow .7s infinite alternate;
}

@keyframes moveArrow{
  0%{ transform:translateX(0); }
  100%{ transform:translateX(6px); }
}

/* MOBILE */

@media(max-width:768px){

  .gallery-item{
    width:240px;
  }

}

</style>